import {
  LOAD_NOTIFICATIONS,
  CREATE_NOTIFICATION,
  SEND_NOTIFICATION,
  DELETE_NOTIFICATION,
  LOAD_RECIPIENTS,
  RECEIVE_NOTIFICATION,
  ASYNC_START,
  ASYNC_END,
} from "../constants/actionTypes";

const defaultState = {
  notifications: null,
  users: null,
  groups: null,
  pagination: {
    total: 0,
    current_page: 1,
    per_page: 15,
    last_page: 1,
    from: 0,
    to: 0,
  },
  currentPage: 1,
  currentLimit: 15,
  currentSearch: "",
  inProgress: false,
  errorMessage: null,
  successMessage: null,
  currentNotification: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ASYNC_START:
      if (
        action.subtype === LOAD_NOTIFICATIONS ||
        action.subtype === CREATE_NOTIFICATION ||
        action.subtype === SEND_NOTIFICATION ||
        action.subtype === DELETE_NOTIFICATION ||
        action.subtype === LOAD_RECIPIENTS
      ) {
        return {
          ...state,
          inProgress: true,
          errorMessage: null,
          successMessage: null,
        };
      }
      return state;

    case ASYNC_END:
      if (
        action.subtype === LOAD_NOTIFICATIONS ||
        action.subtype === CREATE_NOTIFICATION ||
        action.subtype === SEND_NOTIFICATION ||
        action.subtype === DELETE_NOTIFICATION ||
        action.subtype === LOAD_RECIPIENTS
      ) {
        return {
          ...state,
          inProgress: false,
        };
      }
      return state;

    case LOAD_NOTIFICATIONS:
      const payload = action.payload;
      return {
        ...state,
        currentPage: payload?.pagination?.current_page || 1,
        currentLimit: payload?.pagination?.per_page || 15,
        currentSearch: payload?.search || "",
        notifications: payload?.notifications || [],
        pagination: payload?.pagination || {
          ...defaultState.pagination,
          current_page: 1,
          per_page: 15,
          total: 0,
          last_page: 1,
          from: 0,
          to: 0,
          links: [],
        },
        errorMessage: action.error ? "Failed to load notifications" : null,
        successMessage: null,
        inProgress: false,
      };

    case LOAD_RECIPIENTS:
      return {
        ...state,
        users: action.payload?.users || null,
        groups: action.payload?.groups || null,
        errorMessage: action.error ? "Failed to load recipients" : null,
        inProgress: false,
      };

    case CREATE_NOTIFICATION:
      if (action.error) {
        return {
          ...state,
          errorMessage:
            action.payload?.message || "Failed to create notification",
          inProgress: false,
        };
      }
      return {
        ...state,
        notifications: Array.isArray(state.notifications)
          ? [action.payload.notification, ...state.notifications]
          : [action.payload.notification],
        successMessage: "Notification created successfully",
        errorMessage: null,
        inProgress: false,
      };

    case SEND_NOTIFICATION:
      if (action.error) {
        return {
          ...state,
          errorMessage:
            action.payload?.message || "Failed to send notification",
          inProgress: false,
        };
      }
      return {
        ...state,
        notifications: Array.isArray(state.notifications)
          ? state.notifications.map((notification) =>
              notification.id === action.payload?.notification?.id
                ? action.payload.notification
                : notification
            )
          : [],
        successMessage: `Notification sent to ${
          action.payload?.notification?.sent_count || 0
        } recipients`,
        errorMessage: null,
        inProgress: false,
      };

    case DELETE_NOTIFICATION:
      if (action.error) {
        return {
          ...state,
          errorMessage:
            action.payload?.message || "Failed to delete notification",
          inProgress: false,
        };
      }
      return {
        ...state,
        notifications: Array.isArray(state.notifications)
          ? state.notifications.filter(
              (notification) => notification.id !== action.payload.deletedId
            )
          : [],
        successMessage: "Notification deleted successfully",
        errorMessage: null,
        inProgress: false,
      };

    case RECEIVE_NOTIFICATION:
      // Handle incoming real-time notifications
      return {
        ...state,
        // You can add logic here to handle incoming notifications
        // For example, adding them to a separate array for display
      };

    default:
      return state;
  }
};
